import types from '@/data/typeParents.json'
import { commonAPI, postAPI, userAPI } from '@/services-ts/axios'
import type { IGetFilterList, IPayloadFilter } from '@/types/Request'
import type { IFilterStore } from '@/types/Store/State'
import { Alert, Confirm, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useFilterStore = defineStore('filter', {
  state: (): IFilterStore => ({
    filterList: {
      data: [],
      total: 0,
    },
    filtersOperators: {
      full: [],
      lite: [],
    },
    filterValues: {
      city: [],
      community: [],
      department: [],
      employeeType: [],
      gender: [],
      location: [],
      position: [],
      level: [],
    },
  }),

  actions: {
    async GetFilterList(payload: IGetFilterList) {
      const { status, data, total } = await commonAPI.FilterServices.GetFilterList(payload)
      this.filterList = status ? { data: data || [], total: total || 0 } : { data: [], total: 0 }
    },

    async GetFiltersWithCriteria(payload: IGetFilterList) {
      const { status, data, total } = await commonAPI.FilterServices.GetFiltersWithCriteria(payload)
      this.filterList = status ? { data: data || [], total: total || 0 } : { data: [], total: 0 }
    },

    async CreateFilter(payload: IPayloadFilter) {
      const { status, message } = await commonAPI.FilterServices.CreateFilter(payload)

      if (status) {
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      } else {
        await Confirm({
          type: 'danger',
          message: (message || '').replaceAll('|', '\n'),
          title: Format('admin_global_error'),
          confirmText: Format('admin_global_ok'),
          isScrollable: true,
        })
      }
      return status
    },
    async UpdateFilter(payload: IPayloadFilter) {
      const { status, message, data } = await commonAPI.FilterServices.UpdateFilter(payload)

      if (status) {
        const result = data
        const index = this.filterList.data.findIndex(x => x.id === result.id)

        if (index !== -1) this.filterList.data[index] = result

        void Alert({ message: Format('admin_global_success'), type: 'success' })
      } else {
        await Confirm({
          type: 'danger',
          message: (message || '').replaceAll('|', '\n'),
          title: Format('admin_global_error'),
          confirmText: Format('admin_global_ok'),
          isScrollable: true,
        })
      }
      return status
    },
    async DeleteFilter(Id: string) {
      const { status } = await commonAPI.FilterServices.DeleteFilter(Id)

      if (status) {
        this.filterList.data = this.filterList.data.filter(x => x.id !== Id)
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
    },
    async GetFilterValues() {
      const city = await commonAPI.CommonServices.GetCityList()
      const community = await postAPI.CommunityServices.GetCommunityList({
        Skip: null,
        Take: null,
        Id: null,
      })
      const department = await userAPI.DepartmentServices.GetDepartmentList()
      const employeeType = await userAPI.EmployeeTypeServices.GetEmployeeTypeList()
      const gender = await commonAPI.CommonServices.GetTypeList(types.GenderType.id)
      const location = await userAPI.LocationServices.GetLocationList()
      const position = await userAPI.PositionServices.GetPositionList()
      const level = await userAPI.LevelServices.GetLevelList()

      this.filterValues = {
        city: city.data,
        community: community.data,
        department: department.data,
        employeeType: employeeType.data,
        gender: gender.data,
        location: location.data,
        position: position.data,
        level: level.data,
      }
    },
    async GetFilterOperators() {
      const full = await commonAPI.CommonServices.GetTypeList(types.FilterFullOperators.id)
      const lite = await commonAPI.CommonServices.GetTypeList(types.FilterLiteOperators.id)

      this.filtersOperators = {
        full: full.data,
        lite: lite.data,
      }
    },

    GetFilterByIdSync(id: string) {
      const filter = this.filterList.data.find(x => x.id === id)
      return filter || null
    },
  },
})
